import { Box, BoxProps } from '@mui/material';
import { ComponentType } from 'react';
import { Link } from 'react-router-dom';

export const Logo: ComponentType<BoxProps> = (props) => {
  return (
    <Box component={Link} to="/" {...props}>
      {/* display={'flex'} alignItems={'center'} */}
      {/* <SvgIcon
        viewBox="0 0 40 40"
        component={SVGLogo}
        sx={{ fontSize: 'inherit', display: 'block' }}
      /> */}
      <img src="/assets/logo-whites.png" alt="" width={100} />
    </Box>
  );
};
